import { render, staticRenderFns } from "./SuggestedTradeArea.vue?vue&type=template&id=7091c0a5&"
import script from "./SuggestedTradeArea.vue?vue&type=script&lang=js&"
export * from "./SuggestedTradeArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports